import PropTypes from 'prop-types';
import React, { forwardRef, memo } from 'react';
import styled from 'styled-components';

import List from '../List';

const DropDown = forwardRef(function DropDown({ children, listProps = {}, ...props }, ref) {
  return (
    <Root ref={ref} {...props}>
      <List {...listProps}>{children}</List>
    </Root>
  );
});

DropDown.propTypes = {
  /**
   * Dropdown list items.
   */
  children: PropTypes.node.isRequired,
  /**
   * Properties applied to the List component.
   */
  listProps: PropTypes.shape({})
};

const Root = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  width: auto;
  padding: 10px 0;
  margin: 0;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.1);
  transform: translateY(100%);
  z-index: 2;
`;

DropDown.displayName = 'DropDown';

export default memo(DropDown);
